import { IBaseFillInfo } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';

export interface IBaseFill {
    fillInfo: IBaseFillInfo | null;
}

export default class BaseFill implements IBaseFill {
    public fillInfo: IBaseFillInfo | null;
}
